import { FormattedMessage } from 'react-intl';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, Tooltip } from '@mui/material';

function NextDateButton({ selectedDate, setSelectedDate }) {
  return (
    <Tooltip
      arrow
      placement="top"
      title={<FormattedMessage id="NEXT_DAY" defaultMessage="Next Day" />}>
      <Button
        onClick={() => {
          const newDate = selectedDate.add(1, 'day');
          setSelectedDate(newDate);
        }}
        variant="outlined"
        size="small"
        sx={{ minWidth: '0px', padding: '0 2px', marginTop: '-5px' }}>
        <ChevronRightIcon />
      </Button>
    </Tooltip>
  );
}

export default NextDateButton;
